export const MONEY_MULTIPLIER = 100;

export const CARAT_MULTIPLIER = 100;
